var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"word",staticClass:"words",class:[!_vm.showbtn || _vm.expended ? '' : 'expend-box'],attrs:{"content":_vm.text}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.showbtn)?_c('span',{staticClass:"btn",on:{"click":_vm.expendedFunc}},[_vm._v(_vm._s(_vm.expended ? '收起' : '展开'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }